// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetAiAgentsQuery,
    BaseResponseListAiAgentFoundResponse,
    PostAiAgentsBody,
    BaseResponseAiAgentFoundResponse,
} from '../types';

/**
 * findAll
 *
 * @export
 * @tags ai-agent-controller
 * @link [GET] /aiAgents
 */
export function getAiAgents(): Promise<BaseResponseListAiAgentFoundResponse>;
export function getAiAgents(
    options: ApiOptions<never, GetAiAgentsQuery>
): Promise<BaseResponseListAiAgentFoundResponse>;
export function getAiAgents(
    options?: ApiOptions<never, GetAiAgentsQuery>
): Promise<BaseResponseListAiAgentFoundResponse> {
    return request<never, never, GetAiAgentsQuery>('/aiAgents', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAiAgents',
    });
}

/**
 * save
 *
 * @export
 * @tags ai-agent-controller
 * @link [POST] /aiAgents
 */
export function postAiAgents(data: PostAiAgentsBody): Promise<BaseResponseAiAgentFoundResponse>;
export function postAiAgents(
    data: PostAiAgentsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseAiAgentFoundResponse>;
export function postAiAgents(
    data: PostAiAgentsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseAiAgentFoundResponse> {
    return request<PostAiAgentsBody, never, never>('/aiAgents', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postAiAgents',
    });
}

export const meta = [
    { tags: ['ai-agent-controller'], path: '/aiAgents', method: 'get' },
    { tags: ['ai-agent-controller'], path: '/aiAgents', method: 'post' },
];
